import { render, staticRenderFns } from "./CaseManagement.vue?vue&type=template&id=6cf3b686&scoped=true"
import script from "./CaseManagement.vue?vue&type=script&lang=js"
export * from "./CaseManagement.vue?vue&type=script&lang=js"
import style0 from "./CaseManagement.vue?vue&type=style&index=0&id=6cf3b686&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf3b686",
  null
  
)

export default component.exports